import httpClient from './httpClient';

// Define API response type
interface ApiResponse<T> {
  data: T;
  success: boolean;
  message?: string;
  error?: string;
}

export interface Hospital {
  id: string;
  name: string;
  description?: string;
  email?: string;
  phoneNumber?: string;
  mobileNumber?: string;
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  registrationNumber?: string;
  taxId?: string;
  logoUrl?: string;
  bannerUrl?: string;
  status?: string;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export const hospitalApi = {
  // Get company profile
  getCompanyProfile: async (): Promise<Hospital> => {
    try {
      // Try to get the first hospital as the company profile
      const response = await httpClient.get<ApiResponse<Hospital>>('/hospitals/company/profile');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching company profile:', error);
      throw new Error('Failed to fetch company profile');
    }
  },

  // Update company profile
  updateCompanyProfile: async (data: Partial<Hospital>): Promise<Hospital> => {
    try {
      const response = await httpClient.patch<ApiResponse<Hospital>>(
        '/hospitals/company/profile', 
        data
      );
      return response.data.data;
    } catch (error) {
      console.error('Error updating company profile:', error);
      throw new Error('Failed to update company profile');
    }
  },

  // Get hospital by ID
  getHospital: async (id: string): Promise<Hospital> => {
    const response = await httpClient.get<ApiResponse<Hospital>>(`/hospitals/${id}`);
    return response.data.data;
  },

  // Update hospital
  updateHospital: async (id: string, data: Partial<Hospital>): Promise<Hospital> => {
    const response = await httpClient.patch<ApiResponse<Hospital>>(`/hospitals/${id}`, data);
    return response.data.data;
  },

  // Get all hospitals
  getHospitals: async (): Promise<Hospital[]> => {
    const response = await httpClient.get<ApiResponse<Hospital[]>>('/hospitals');
    return Array.isArray(response.data.data) ? response.data.data : [];
  },

  // Create hospital
  createHospital: async (data: Omit<Hospital, 'id' | 'createdAt' | 'updatedAt'>): Promise<Hospital> => {
    const response = await httpClient.post<ApiResponse<Hospital>>('/hospitals', data);
    return response.data.data;
  },
};
